<ng-template #scoreAnalysis let-modal>
  <div class="modal-content" style="height: 100vh">
    <div class="modal-header">
      <!-- SM-4061: Show the form name above the "Scores" heading -->
      <div class="modal-title">
        @if (msfps.formTitle) {
        <div class="fs-6 fw-bold text-muted">{{ msfps.formTitle }}</div>
        }
        <h5 class="fw-bold mb-0">Scores</h5>
      </div>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    @if (data) {
    <div class="modal-body p-3">
      <!-- <pre>{{ data | json }}</pre> -->
      @for (cqObj of data | keyvalue: asIsOrder; track cqObj) {
      <section class="mb-4">
        @if (cqObj.key !== "response") {
        <h6 class="fw-bold">{{ getSectionHeadingLabel(cqObj.key) }}</h6>
        <!-- <pre>{{ cqObj.value | json }}</pre> -->
        @if (cqObj.key == "cmmC_Statuses") {
        <table class="table table-bordered mb-0">
          <thead>
            <tr style="background-color: yellow;">
              <th>CMMC_Statuses</th>
              <th>Last_Assesment_Date</th>
              <th>Last_Affirmation_Date</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            @for (detailingObj of getAsArray(cqObj.value); track detailingObj) {
            <tr>
              <td>{{ detailingObj["label"] }}</td>
              <td>{{ detailingObj["last_Assesment_Date"] }}</td>
              <td>{{ detailingObj["last_Affirmation_Date"] }}</td>
              <td [ngStyle]="{'color': detailingObj['colorCode'] || 'inherit'}">{{ detailingObj["status"] }}</td>
            </tr>
            }
          </tbody>
        </table>
        } @else if (cqObj.key == "risk" && msfps.isReviewClicked && msfps.formType === 'CMMC') {
        @for (
        detailingObj of getAsArray(cqObj.value);
        track detailingObj
        ) {

        <div class="row d-flex align-items-center justify-content-start">
          <!-- <pre>{{ detailingObj | json }}</pre> -->
          <span class="col-sm-6 col-md-5 col-lg-4 fw-normal">{{
            detailingObj["label"]
            }}</span>
          <div class="col-sm-6 col-md-7 col-lg-8 d-flex align-items-center justify-content-start">
            &colon;&nbsp;&nbsp;&nbsp;
            <!-- <i [class]="legend[detailingObj['Score']]"></i>&nbsp;&nbsp; -->
            <span>{{ detailingObj["score"] }}</span>
          </div>
        </div>
        }
        <!-- SM-4061: restores the SM-2932 label, lost by revert commit 8700e50 -->
        <h6 class="fw-bold mt-3">CCRA - Risk Form Assignment @if(shouldAssignLinkedForm(cqObj.value)) {
          <span class="badge text-bg-danger">REQUIRED</span>}
        </h6> 
        @if(shouldAssignLinkedForm(cqObj.value)) {
        <p class="mb-3">Based on your responses, a Risk Assessment is required. Please assign this form to a user who will complete it.</p>
        
        <!-- SM-1127: Risk Form Assignment Dropdown -->
        <div class="mb-3">
          <label for="assignTo" class="fw-bold">Assign To <span class="text-danger">*</span></label>
          <select id="assignTo" class="form-select mt-1" style="max-width: 450px;" 
            [(ngModel)]="assignToSelection" 
            (change)="onAssignmentSelectionChange()">
            <option [ngValue]="null">Select a user...</option>
            <option [ngValue]="'self'">{{ currentUserDisplayName }} (Me)</option>
            @for (option of supplierAdminUserList; track option) {
            <option [ngValue]="option">
              {{ option.Text }} ({{ option.Email }})
            </option>
            }
            <option [ngValue]="'newUser'">+ Request New User</option>
          </select>
        </div>
        
        <!-- Request New User Panel -->
        @if (assignToSelection === 'newUser') {
          <div class="card border-secondary" style="max-width: 450px;">
            <div class="card-body">
              <h6 class="card-title fw-bold">Request New User</h6>
              <p class="card-text text-muted small fst-italic mb-3">
                Enter the details of the user you'd like to request. The new user will receive an activation email and follow the standard activation process. Note: Your organization's admin will need to log in to MAG and send the activation email to the new user.
              </p>
              
              <div class="row mb-3">
                <div class="col-6">
                  <label for="firstName" class="form-label">First Name <span class="text-danger">*</span></label>
                  <input type="text" class="form-control" id="firstName" 
                    [(ngModel)]="newUserFirstName" required
                    placeholder="John">
                </div>
                <div class="col-6">
                  <label for="lastName" class="form-label">Last Name <span class="text-danger">*</span></label>
                  <input type="text" class="form-control" id="lastName" 
                    [(ngModel)]="newUserLastName" required
                    placeholder="Doe">
                </div>
              </div>
              
              <div class="mb-3">
                <label for="email" class="form-label">Email Address <span class="text-danger">*</span></label>
                <input type="email" class="form-control" id="email" 
                  [(ngModel)]="newUserEmail" required
                  (blur)="validateEmail()"
                  [class.is-invalid]="!isEmailValid && newUserEmail"
                  placeholder="john.doe@company.com">
                @if (!isEmailValid && emailValidationMessage) {
                  <div class="invalid-feedback d-block">{{ emailValidationMessage }}</div>
                }
              </div>
              
              <p class="text-muted small fst-italic mb-0">
                While the new user completes activation, the form may be automatically reassigned to an existing user so that provisioning can continue. Once the new user activates their account, your organization admin can reassign the form to the new user.
              </p>
            </div>
          </div>
        }
        
        } @else {
        <div class="alert alert-success mt-2">Based on your responses, a Risk Assessment is not required at this time.
          You may proceed with submitting your form.</div>
        }
        } @else if (cqObj.key == "risk") {
        
        @for (
        detailingObj of getAsArray(cqObj.value);
        track detailingObj
        ) {

        <div class="row d-flex align-items-center justify-content-start">
          <!-- <pre>{{ detailingObj | json }}</pre> -->
          <span class="col-sm-6 col-md-5 col-lg-4 fw-normal">{{
            detailingObj["label"]
            }}</span>
          <div class="col-sm-6 col-md-7 col-lg-8 d-flex align-items-center justify-content-start">
            &colon;&nbsp;&nbsp;&nbsp;
            <!-- <i [class]="legend[detailingObj['Score']]"></i>&nbsp;&nbsp; -->
            <span>{{ detailingObj["score"] }} </span>
          </div>
        </div>
        }

        } @else {
        @for (
        detailingObj of getAsArray(cqObj.value);
        track detailingObj
        ) {

        <div class="row d-flex align-items-center justify-content-start">
          <!-- <pre>{{ detailingObj | json }}</pre> -->
          <span class="col-sm-6 col-md-5 col-lg-4 fw-normal">{{
            detailingObj["label"]
            }}</span>
          <div class="col-sm-6 col-md-7 col-lg-8 d-flex align-items-center justify-content-start">
            &colon;&nbsp;&nbsp;&nbsp;
            <!-- <i [class]="legend[detailingObj['Score']]"></i>&nbsp;&nbsp; -->
            <span>{{ detailingObj["score"] }}</span>
          </div>
        </div>
        }
        }
        }
      </section>
      }
    </div>
    }
    <div class="modal-footer">

      @if(msfps.isReviewClicked && msfps.formType === 'CMMC') {
      <button type="button" class="btn btn-outline-dark" (click)="modal.close('Close click')">
        Close
      </button>
      <button type="button" class="btn btn-primary" 
        [disabled]="!canSubmitForm() || isAssigning" 
        (click)="submitWithRiskFormAssignment()">
        @if (isAssigning) {
          <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
          Processing...
        } @else {
          Submit
        }
      </button>
      } @else {
      <button type="button" class="btn btn-danger" (click)="resetValues();modal.close('Close click')">
        Close
      </button>
      }
    </div>
  </div>
</ng-template>